import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { GET_PRODUCTS_BY_SKUS } from "../../operations/queries/operations/queries/get-products-by-skus.js";
const mapResultToProducts = (data) => {
  const products = data?.getProductsBySKUs;
  if (!products) {
    return;
  }
  return products.flatMap((product) => {
    return product.variants.map((variant) => {
      const image = variant.media.images[0];
      return {
        __itemType: "product",
        name: product.name,
        slug: product.slug,
        sku: variant.sku,
        price: {
          amount: variant.prices.discountedPrice?.price?.amount || variant.prices.originalPrice?.amount,
          currencyCode: variant.prices.discountedPrice?.price?.currencyCode || variant.prices.originalPrice?.currencyCode
        },
        image: image ? {
          url: image.url,
          dimensions: {
            width: image.dimensions.w,
            height: image.dimensions.h
          },
          label: image.label ?? void 0
        } : null
      };
    });
  });
};
const useProducts = () => {
  const [query, { called, data, error, loading }] = useLazyQuery(GET_PRODUCTS_BY_SKUS, {
    onError(error2) {
      console.error(error2);
      toast.failed("tryInStore.component.selectionModal.fetchError");
    }
  });
  const trigger = React.useCallback(
    (skus) => {
      query({ variables: { skus } });
    },
    [query]
  );
  const state = React.useMemo(
    () => ({
      called,
      data: mapResultToProducts(data),
      error,
      loading
    }),
    [called, data, error, loading]
  );
  return React.useMemo(() => [trigger, state], [trigger, state]);
};
export {
  useProducts
};
//# sourceMappingURL=use-products.js.map
